<script>
    /**
     * The width of the SVG
     */
    export let width;

    /**
     * The height of the SVG
    */
    export let height;

    /**
     * A description of the graphic, for screenreader support.
    */
    export let description;

    /**
     * The ARIA role for the graphic. Defaults to "img" (or image).
     */
    export let role = "img";

    /**
     * The ID of the SVG title
    */
    export let titleId;
</script>

    <svg role={role} width={width} height={height} xlmns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet" viewBox={`0 0 ${width} ${height}`}
        aria-labelledby={titleId} {...$$restProps}>
        {#if description}<title id={titleId}>{description}</title>{/if}
        <slot></slot>
    </svg>
<style>

</style>